import {createBrowserHistory, createHashHistory} from 'history';

const history = (document.URL.indexOf( 'http://' ) === -1 && document.URL.indexOf( 'https://' ) === -1) ? createHashHistory({
    basename: process.env.PUBLIC_URL
}) : createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

export default history
